import axios from "axios";
import apiEndpoints from "../config/apiEndpoints";
import { fetchData } from "../utils/utils";

export const getEventsOrStandardTickets = async (
  key,
  lang,
  iswidget,
  isStandardTicket
) => {
  const endpoint = apiEndpoints.TICKETING.GET_EVENTS_OR_STANDARD_TICKETS(
    key,
    lang,
    iswidget,
    isStandardTicket
  );
  const result = await fetchData({ endpoint, method: "GET" });
  return result;
};

export const fetchStandardTicketsDates = async (key) => {
  const endpoint = apiEndpoints.TICKETING.GET_STD_TICKETS_DATES(key);
  const result = await fetchData({ endpoint, method: "GET" });
  return result;
};
export const fetchEventTicketsDates = async (eventTicketId) => {
  const endpoint = apiEndpoints.TICKETING.GET_EVENT_TICKET_DATES(eventTicketId);
  const result = await fetchData({ endpoint, method: "GET" });
  return result;
};

export const fetchEventOrStandardTicketsTypes = async (
  key,
  lang,
  ticketId,
  date,
  isStandardTicket
) => {
  const endpoint = apiEndpoints.TICKETING.GET_EVENTS_OR_STANDARD_TICKETS_TYPES(
    key,
    lang,
    ticketId,
    date,
    isStandardTicket
  );
  const result = await fetchData({ endpoint, method: "GET" });
  return result;
};

export const CreateTicketingReservation = async (payload) => {
  // Ensure all required parameters are provided
  const endpoint = apiEndpoints.TICKETING.CREATE_TICKET_RESERVATION;
  const result = await fetchData({ endpoint, method: "POST", data: payload });
  if (result?.error) {
    throw new Error(result.error)
  }
  return result;
};

export const getCombinationList = async (payload) => {
  const endpoint = apiEndpoints.Activites.GET_COMBINATION_LIST;
  const result = await fetchData({ endpoint, method: "Post", data: payload });
  if (!result.success) {
    console.error(result.message);
  } else {
    console.log("Combination List:", result);
  }
  return result;
};
